import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonSpinner } from '@ionic/react';
import checkoutClient from '../logic/checkout';

// orderId arrives only once the receipt has been sent to Billd: until then
// the customer is asked to wait, otherwise they would just close the page.
export default function BilldReceiptButton(props) {
    const { orderId } = props;

    const { t } = useTranslation();

    const [loading, setLoading] = React.useState(false);

    async function openPreview() {
        setLoading(true);
        try {
            const previewUrl = await checkoutClient.getBilldPreviewUrl(orderId);
            if (previewUrl) {
                window.location.href = previewUrl;
                return;
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }

    if (!orderId) {
        return (
            <div className="flex flex-col items-center my-2 py-2">
                <IonSpinner name="dots"></IonSpinner>
                <p className="font-bold">{t("billdreceiptbutton.p_1")}</p>
            </div>
        );
    }

    return (
        <button type="button" onClick={openPreview} disabled={loading} className="block w-full my-2 py-2 rounded-full bg-mycia-green uppercase disabled:opacity-50">
            {t("billdreceiptbutton.button_1")}
        </button>
    );
}
